import { NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit, model, output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizationService } from '../../../../modules/fwcore';
import { DealsService } from '../../../prob/services';
import { AdminService } from '../../services';
import { ImpersonationService } from '@mysrc/app/modules/fwcore/services/impersonation.service';

@Component({
  selector: 'app-impersonation-current',
  standalone: true,
  imports: [NgClass, ButtonsModule],
  templateUrl: './impersonation-current.component.html',
  styleUrl: './impersonation-current.component.scss'
})
export class ImpersonationCurrentComponent implements OnInit, OnDestroy {

  // ---------------- Hybrid old/new input ----------------

  public impersonating = model('');
  public impersonateChanged = output<string>();


  //----------------- Control handling   ------------------

  protected impersonatingEmail?: string | null;

  //----------------- State properties  ------------------

  protected destroy$ = new Subject();

  //----------------- Constructor  ------------------

  constructor(protected router: Router
    , protected adminService: AdminService
    , protected authService: AuthorizationService
    , protected dealService: DealsService
    , protected impersonation: ImpersonationService
  ) {

  }

  //----------------- ng  ---------------------------

  ngOnInit(): void {

    this.impersonating.set(this.impersonation.name ?? '');

    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.refreshImpersonating();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //----------------- Control processing   ------------------

  protected refreshImpersonating() {

    this.impersonating.set(this.impersonation.name ?? '');
    this.impersonateChanged.emit(this.impersonation.get() ?? '');

  }

  protected onStopImpersonating() {

    this.impersonation.reset();  
    this.impersonating.set('');

    this.impersonateChanged.emit('');
    this.router.navigate(['./home']);
  }

}
